import { render, staticRenderFns } from "./reportGl.vue?vue&type=template&id=10c1a473&scoped=true&"
import script from "./reportGl.vue?vue&type=script&lang=js&"
export * from "./reportGl.vue?vue&type=script&lang=js&"
import style0 from "./reportGl.vue?vue&type=style&index=0&id=10c1a473&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10c1a473",
  null
  
)

export default component.exports